// export const createConsultationGroupWithUsers = async (
//   tinode,
//   userIds,
//   options = {},
// ) => {
//   console.log("INI OPTIONS", options);
//   try {
//     if (!tinode || !tinode.isConnected()) {
//       throw new Error("Tinode not connected");
//     }

//     const randomSuffix = Math.random().toString(36).substring(2, 11);
//     // const groupName = options.customerName || `Konsultasi(${randomSuffix})`;
//     const groupName = options.customerName;

//     const topicRandomId = Math.random().toString(36).substring(2, 11);
//     const topicName = `new${topicRandomId}`;

//     let topic = tinode.getTopic(topicName);
//     if (!topic) {
//       topic = tinode.initTopic(topicName);
//     }

//     try {
//       await topic.setMeta({
//         desc: {
//           public: {
//             fn: groupName,
//             customerName: options.customerName,
//             doctorName: "Dr. Clara aja",
//             note: options.note || "␡",
//           },
//         },
//       });
//     } catch (metaError) {
//       console.warn(
//         "⚠️ Failed to set initial metadata (will retry after subscribe):",
//         metaError,
//       );
//     }

//     if (!topic.isSubscribed()) {
//       try {
//         const metaQuery = topic.startMetaQuery().build();

//         await topic.subscribe(metaQuery);
//         await new Promise((resolve) => setTimeout(resolve, 300));

//         try {
//           await topic.setMeta({
//             desc: {
//               public: {
//                 fn: groupName,
//                 note: options.note || "␡",
//               },
//             },
//           });
//           console.log(`✅ Metadata confirmed for topic: ${topicName}`);
//         } catch (verifyError) {
//           console.warn(
//             "⚠️ Failed to verify metadata (non-fatal):",
//             verifyError,
//           );
//         }
//       } catch (subscribeError) {
//         console.error("❌ Failed to subscribe/create topic:", subscribeError);
//         throw new Error(
//           `Failed to create topic: ${subscribeError.message || subscribeError}`,
//         );
//       }
//     } else {
//       try {
//         await topic.setMeta({
//           desc: {
//             public: {
//               fn: groupName,
//               customerName: options.customerName,
//               doctorName: "Dr. Clara aja",
//               note: options.note || "␡",
//             },
//           },
//         });
//         console.log(`✅ Metadata set for existing topic: ${topicName}`);
//       } catch (metaError) {
//         console.warn("⚠️ Failed to set metadata (non-fatal):", metaError);
//       }
//     }

//     const userIdsArray = Array.isArray(userIds) ? userIds : [userIds];
//     const userIdsToInvite = userIdsArray.filter((id) => id && id.trim());

//     if (userIdsToInvite.length > 0) {
//       console.log(`👥 Inviting users to group: ${userIdsToInvite.join(", ")}`);
//       await new Promise((resolve) => setTimeout(resolve, 500));

//       for (const userId of userIdsToInvite) {
//         try {
//           const formattedUserId = userId.startsWith("usr")
//             ? userId
//             : `usr${userId}`;

//           console.log(
//             `📤 Inviting user: ${formattedUserId} to topic: ${topicName}`,
//           );

//           await topic.setMeta({
//             sub: {
//               user: formattedUserId,
//             },
//           });

//           console.log(`✅ User ${formattedUserId} invited successfully`);

//           await new Promise((resolve) => setTimeout(resolve, 200));
//         } catch (inviteError) {
//           if (
//             inviteError?.code === 304 ||
//             inviteError?.text === "not modified"
//           ) {
//             console.log(
//               `ℹ️ User ${userId} already in group (304 not modified)`,
//             );
//           } else if (inviteError?.code === 200) {
//             console.log(`✅ User ${userId} invited successfully (200 OK)`);
//           } else {
//             console.warn(`⚠️ Failed to invite user ${userId}:`, inviteError);
//           }
//         }
//       }

//       console.log(
//         `✅ Invite process completed for ${userIdsToInvite.length} user(s)`,
//       );

//       // Kirim pesan greeting otomatis setelah dokter di-invite
//       // Ini memastikan dokter mendapatkan notifikasi pesan baru secara realtime
//       try {
//         await new Promise((resolve) => setTimeout(resolve, 600));
//         const customerName =
//           options.customerName ||
//           (typeof localStorage !== "undefined"
//             ? localStorage.getItem("fullname")
//             : null) ||
//           "Pasien";

//         const greetingText =
//           `Halo Dokter, saya ${customerName}. ` +
//           `Saya ingin berkonsultasi dengan Anda. Mohon bantuannya 🙏`;

//         await topic.publish(greetingText);
//         console.log("✅ Greeting message sent successfully");
//       } catch (greetingError) {
//         // Non-fatal: gagal kirim greeting tidak batalkan pembuatan group
//         console.warn("⚠️ Failed to send greeting message:", greetingError);
//       }
//     }

//     const finalTopicName = topic.name || topicName;

//     console.log(`✅ Consultation group created successfully!`);
//     console.log(`   Group Name: ${groupName}`);
//     console.log(`   Topic Name: ${finalTopicName}`);
//     console.log(`   Members: ${userIdsToInvite.length} user(s) invited`);

//     return {
//       topic,
//       topicName: finalTopicName,
//       groupName,
//       invitedUsers: userIdsToInvite,
//       success: true,
//     };
//   } catch (error) {
//     console.error("❌ Failed to create consultation group:", error);
//     throw error;
//   }
// };

// export const createConsultationGroup = async (tinode, userId, options = {}) => {
//   return await createConsultationGroupWithUsers(tinode, userId, options);
// };

import {
  attemptTinodeRelogin,
  connectTinodeInstance,
} from "./tinodeSingleton";

export const createConsultationGroupWithUsers = async (
  tinode,
  userIds,
  options = {},
) => {
  try {
    if (!tinode) {
      throw new Error("Tinode instance not available");
    }

    if (!tinode.isConnected()) {
      await connectTinodeInstance(tinode);
    }

    if (!tinode.isAuthenticated()) {
      const relogged = await attemptTinodeRelogin(tinode);
      if (!relogged || !tinode.isAuthenticated()) {
        throw new Error("Authentication required. Please login again.");
      }
    }

    const groupName = options.customerName || "Konsultasi";
    const requestedTopicName =
      typeof options.topicName === "string" &&
      options.topicName.trim().length > 0
        ? options.topicName.trim()
        : `new${Math.random().toString(36).substring(2, 11)}`;

    let topic = tinode.getTopic(requestedTopicName);
    if (!topic) {
      topic = tinode.initTopic(requestedTopicName);
    }

    const buildFn = (
      doctorName,
      doctorProfile,
      doctorSip,
      doctorSpecialty,
      customerName,
      customerProfile,
      customerAge,
      customerGender,
      customerType,
    ) => {
      return JSON.stringify({
        doctorName: doctorName || undefined,
        doctorProfile: doctorProfile || undefined,
        doctorSip: doctorSip || undefined,
        doctorSpecialty: doctorSpecialty || undefined,
        customerName: customerName || undefined,
        customerProfile: customerProfile || undefined,
        customerAge: customerAge || undefined,
        customerGender: customerGender || undefined,
        customerType: customerType || undefined,
      });
    };

    const fnValue = buildFn(
      options.doctorName,
      options.doctorProfile,
      options.doctorSip,
      options.doctorSpecialty,
      options.customerName,
      options.customerProfile,
      options.customerAge,
      options.customerGender,
      options.customerType,
    );

    let serverTopicName = "";
    if (!topic.isSubscribed()) {
      try {
        const metaQuery = topic.startMetaQuery().build();
        const subscribeResult = await topic.subscribe(metaQuery);
        serverTopicName = subscribeResult?.ctrl?.topic || "";
        await new Promise((resolve) => setTimeout(resolve, 300));
      } catch (subscribeError) {
        const isAuthError =
          subscribeError?.code === 401 ||
          subscribeError?.text === "authentication required" ||
          subscribeError?.message?.includes("authentication required");

        if (isAuthError) {
          const relogged = await attemptTinodeRelogin(tinode);
          if (relogged && tinode.isAuthenticated()) {
            let retryTopic = tinode.getTopic(requestedTopicName);
            if (!retryTopic) {
              retryTopic = tinode.initTopic(requestedTopicName);
            }

            const retryMetaQuery = retryTopic.startMetaQuery().build();
            const retrySubscribeResult = await retryTopic.subscribe(
              retryMetaQuery,
            );
            serverTopicName = retrySubscribeResult?.ctrl?.topic || "";
            topic = retryTopic;
            await new Promise((resolve) => setTimeout(resolve, 300));
          } else {
            throw new Error("Failed to create topic: authentication required (401)");
          }
        } else {
          console.error("Failed to subscribe/create topic:", subscribeError);
          throw new Error(
            `Failed to create topic: ${subscribeError.message || subscribeError}`,
          );
        }
      }
    }

    try {
      await topic.setMeta({
        desc: {
          public: {
            fn: fnValue,
          },
        },
      });
    } catch (metaError) {
      console.warn("Failed to set metadata:", metaError);
    }

    const userIdsArray = Array.isArray(userIds) ? userIds : [userIds];
    const userIdsToInvite = userIdsArray.filter((id) => id && id.trim());

    if (userIdsToInvite.length > 0) {
      await new Promise((resolve) => setTimeout(resolve, 500));

      for (const userId of userIdsToInvite) {
        try {
          const formattedUserId = userId.startsWith("usr")
            ? userId
            : `usr${userId}`;

          await topic.setMeta({
            sub: {
              user: formattedUserId,
            },
          });

          await new Promise((resolve) => setTimeout(resolve, 200));
        } catch (inviteError) {
          if (
            inviteError?.code === 304 ||
            inviteError?.text === "not modified"
          ) {
            // Already in group.
          } else if (inviteError?.code === 200) {
            // Invite acknowledged by server.
          } else {
            console.warn(`Failed to invite user ${userId}:`, inviteError);
          }
        }
      }

      try {
        await new Promise((resolve) => setTimeout(resolve, 600));
        const customerName =
          options.customerName ||
          (typeof localStorage !== "undefined"
            ? localStorage.getItem("fullname")
            : null) ||
          "Pasien";

        const greetingText =
          `Halo Dokter, saya ${customerName}. ` +
          `Saya ingin berkonsultasi dengan Anda. Mohon bantuannya 🙏`;

        await topic.publish(greetingText);
      } catch (greetingError) {
        console.warn("Failed to send greeting message:", greetingError);
      }
    }

    const finalTopicName = serverTopicName || topic.name || requestedTopicName;

    return {
      topic,
      topicName: finalTopicName,
      groupName,
      invitedUsers: userIdsToInvite,
      success: true,
    };
  } catch (error) {
    console.error("Failed to create consultation group:", error);
    throw error;
  }
};

export const createConsultationGroup = async (tinode, userId, options = {}) => {
  return await createConsultationGroupWithUsers(tinode, userId, options);
};

/**
 * Parse fn dari topic public menjadi object metadata konsultasi.
 *
 * Tinode hanya menyimpan field "fn" di public desc, jadi kita encode
 * semua metadata sebagai JSON string di dalam fn.
 *
 * Penggunaan:
 *   const topic = tinode.getTopic(topicName);
 *   const meta = parseTopicFn(topic.public?.fn);
 *   console.log(meta.customerName, meta.doctorName, meta.note);
 */
export const parseTopicFn = (fn) => {
  try {
    const parsed = JSON.parse(fn);
    return {
      doctorName: parsed.doctorName || "",
      doctorProfile: parsed.doctorProfile || "",
      doctorSip: parsed.doctorSip || "",
      doctorSpecialty: parsed.doctorSpecialty || "",
      customerName: parsed.customerName || "",
      customerProfile: parsed.customerProfile || "",
      customerAge: parsed.customerAge || 0,
      customerGender: parsed.customerGender || 0,
      customerType: parsed.customerType || 0,
    };
  } catch {
    // fn bukan JSON — topic lama dengan fn berupa string biasa
    return {
      doctorName: "",
      doctorProfile: "",
      doctorSip: "",
      doctorSpecialty: "",
      customerName: fn || "",
      customerProfile: "",
      customerAge: 0,
      customerGender: 0,
      customerType: 0,
    };
  }
};
